module.exports = {
  // http: 'http://169.254.152.216:7000',
  http: 'https://first-resp.cacbjy.com',
  url: 'https://first-resp.cacbjy.com/scheduling',
  websocketUrl: 'first-resp.cacbjy.com/scheduling',
};
